var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAttemptedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 21",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.75 20.16L10 17.16L11.16 16L12.75 17.59L16.34 14L17.5 15.41L12.75 20.16ZM14 0C15.1 0 16 0.9 16 2V11.34C15.37 11.12 14.7 11 14 11V2H9V10L6.5 7.75L4 10V2H2V18H8.08C8.2 18.72 8.45 19.39 8.8 20H2C0.9 20 0 19.1 0 18V2C0 0.9 0.9 0 2 0H14Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttemptedIcon);
export default __webpack_public_path__ + "static/media/AttemptedIcon.0a5850edd12ea0ffc46a2cf59c32802e.svg";
export { ForwardRef as ReactComponent };